import { Modal, Stack, Text, Title, Anchor } from "@mantine/core";

interface PrivacyModalProps {
  opened: boolean;
  onClose: () => void;
}

export const PrivacyModal = ({ opened, onClose }: PrivacyModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Title order={3}>Privacy Policy</Title>}
      size="lg"
      centered
      padding="xl"
      transitionProps={{
        transition: "fade",
        duration: 150,
        exitDuration: 150,
      }}
      overlayProps={{
        opacity: 0.5,
        blur: 2,
      }}
      styles={{
        content: {
          background: `
            radial-gradient(circle at 20% 30%, var(--theme-overlay-20) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, var(--theme-overlay-15) 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, var(--theme-overlay-12) 0%, transparent 70%),
            var(--theme-bg-modal)
          `,
          boxShadow:
            "0 20px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px var(--theme-border)",
        },
        body: {
          background: "transparent",
        },
        header: {
          background: "transparent",
        },
        title: {
          color: "white",
        },
      }}
    >
      <Stack gap="md">
        <Title order={5} c="white">
          What we collect
        </Title>
        <Text size="sm" c="dimmed">
          When you sign up for price alerts, we store:
        </Text>
        <Text
          size="sm"
          c="dimmed"
          component="ul"
          style={{ margin: 0, paddingLeft: "1.5rem" }}
        >
          <li>Your email address</li>
          <li>Your alert preferences (GPU model and target price)</li>
        </Text>
        <Text size="sm" c="dimmed">
          No tracking, no cookies, no analytics.
        </Text>

        <Title order={5} c="white">
          Why we collect it
        </Title>
        <Text size="sm" c="dimmed">
          To send you price alerts when GPUs drop to your target price.
        </Text>

        <Title order={5} c="white">
          Who has access
        </Title>
        <Text
          size="sm"
          c="dimmed"
          component="ul"
          style={{ margin: 0, paddingLeft: "1.5rem" }}
        >
          <li>Us - to operate the service</li>
          <li>
            Resend - our email provider, to deliver emails to you (
            <Anchor
              href="https://resend.com/legal/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              size="sm"
            >
              privacy policy
            </Anchor>
            )
          </li>
        </Text>
        <Text size="sm" c="dimmed">
          We don't sell or share your data with anyone else.
        </Text>

        <Title order={5} c="white">
          How long we keep it
        </Title>
        <Text size="sm" c="dimmed">
          Until you unsubscribe. When you click unsubscribe, your data is
          deleted immediately. Or when the service shuts down.
        </Text>

        <Title order={5} c="white">
          Your rights
        </Title>
        <Text size="sm" c="dimmed">
          You can:
        </Text>
        <Text
          size="sm"
          c="dimmed"
          component="ul"
          style={{ margin: 0, paddingLeft: "1.5rem" }}
        >
          <li>
            Delete your data by clicking unsubscribe in any alert email. No
            stored alert, no stored email.
          </li>
          {/*<li>
            Contact us at email{" "}
            <Anchor href="mailto:hello@gpu-o-lock.com" size="sm">
              hello@gpu-o-clock.com
            </Anchor>{" "}
          </li>*/}
        </Text>

        <Title order={5} c="white">
          Changes
        </Title>
        <Text size="sm" c="dimmed">
          If we change this policy, we'll update the date below.
        </Text>

        <Text size="xs" c="dimmed">
          Last updated: November 2025
        </Text>
      </Stack>
    </Modal>
  );
};
